import { render } from "./_table_data.vue?vue&type=template&id=3ebce33d&scoped=true"
import script from "./_table_data.vue?vue&type=script&lang=js"
export * from "./_table_data.vue?vue&type=script&lang=js"

import "./_table_data.vue?vue&type=style&index=0&id=3ebce33d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebce33d"]])

export default __exports__